import React from 'react';
import { ButtonPrimary, ButtonDanger } from '../StyledComponent';
import { Container } from './styles';

const HeaderSection = ({
  tema,
  title,
  subtitle,
  onEdit,
  onCancel,
  isEditable,
  setIsEditable,
  marginTop,
  mobileMarginTop,
  marginBottom,
  haveAnyFieldsEditing,
  notShowButton,
  isLoading,
}) => {
  const isShowButtonEdit = !isEditable && !notShowButton;
  const isShowButtonCancel = isEditable && !notShowButton;

  function handleEdit() {
    onEdit(isEditable, setIsEditable);
  }

  function handleCancel() {
    onCancel(isEditable, setIsEditable);
  }

  return (
    <Container
      tema={tema}
      marginTop={marginTop}
      mobileMarginTop={mobileMarginTop}
      marginBottom={marginBottom}
    >
      <div className='titles-container'>
        <h2 className='title'>{title}</h2>
        {subtitle && <span className='subtitle'>{subtitle}</span>}
      </div>

      {isShowButtonEdit && (
        <ButtonPrimary
          tema={tema}
          onClick={handleEdit}
          disabled={haveAnyFieldsEditing}
        >
          EDITAR
        </ButtonPrimary>
      )}

      {isShowButtonCancel && (
        <ButtonDanger light onClick={handleCancel} disabled={isLoading}>
          CANCELAR
        </ButtonDanger>
      )}
    </Container>
  );
};

export default HeaderSection;
